<template>
  <div class="page">
    <IframePage :title="title" :url="guideUrl" background-color="#ffffff" />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import IframePage from "@/components/iframe.vue";

const { t, locale } = useI18n();
const route = useRoute();

const guideConfig = computed(() => route.meta.externalGuide);
const title = computed(() => t(guideConfig.value.titleKey));
const guideLocale = computed(() => {
  const separator = guideConfig.value.localeSeparator;
  return separator ? locale.value.replace(/[-_]/g, separator) : locale.value;
});
const guidePath = computed(() => {
  const basePath = String(guideConfig.value.basePath ?? "userGuide").replace(
    /^\/+|\/+$/g,
    "",
  );
  return [
    basePath,
    guideConfig.value.folder,
    `${guideConfig.value.file}_${guideLocale.value}.html`,
  ]
    .filter(Boolean)
    .join("/");
});
const guideUrl = computed(() => `https://winpay.com/${guidePath.value}`);
</script>

<style scoped lang="scss">
.page {
  :deep(.van-nav-bar__title) {
    color: #000 !important;
  }
}
</style>
